import { getWsBasePath } from "../utils";
import { WecomAddOriginType } from "../types";
export const WECOM_ACCOUNT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/QW/ACCOUNT`;
export const WECOM_CONTACT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/QW/CONTACT`;
export const WECOM_CHAT_WS_ADDRESS = `${getWsBasePath()}/api/damselfish-chat-bot/ws/QW/CHAT`;

export const wecomAddOrigins = {
  [WecomAddOriginType.BY_SCAN]: "对方通过扫一扫添加",
  [WecomAddOriginType.SEARCH_TEL]: "通过搜索手机号添加",
  [WecomAddOriginType.BY_BUSINESS_CARD]: "对方通过名片分享添加",
  [WecomAddOriginType.BY_ROOM]: "通过群聊添加",
  [WecomAddOriginType.BY_WECHAT_FRIEND]: "通过微信好友添加",
  [WecomAddOriginType.BY_SCAN_51]: "对方通过扫一扫添加",
  [WecomAddOriginType.BY_SCAN_103]: "对方通过扫一扫添加",
  [WecomAddOriginType.BY_SCAN_122]: "通过扫一扫添加",
};
